var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 0C15.6426 0 14.4983 0.389557 13.4897 1.15788C12.5228 1.89447 11.879 2.83265 11.5 3.51487C11.121 2.83261 10.4772 1.89447 9.51028 1.15788C8.50169 0.389557 7.35744 0 6.10938 0C2.62649 0 0 2.80606 0 6.52717C0 10.5473 3.27674 13.2977 8.23728 17.4616C9.07965 18.1687 10.0345 18.9702 11.0269 19.825C11.1577 19.9379 11.3257 20 11.5 20C11.6743 20 11.8423 19.9379 11.9731 19.8251C12.9656 18.9701 13.9204 18.1687 14.7633 17.4612C19.7233 13.2977 23 10.5473 23 6.52717C23 2.80606 20.3735 0 16.8906 0Z",
    fill: "#7FB432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveShape2);
export default __webpack_public_path__ + "static/media/love-shape2.4aaeb3c046cefd61ebb0b2075d27318b.svg";
export { ForwardRef as ReactComponent };